"use client";

import { usePath, useRouter, useSearch } from "@packages/framework";
import { useCallback } from "react";

export const useRedirects = () => {
  const router = useRouter();
  const pathname = usePath();
  const searchParams = useSearch();

  const redirectToSubscribe = useCallback(
    async ({
      newWindow = false,
      redirectBackOnSubscription = true,
    }: { newWindow?: boolean; redirectBackOnSubscription?: boolean } = {}) => {
      if (redirectBackOnSubscription) {
        const currentSearch = searchParams.toString();
        const fullPath = currentSearch
          ? `${pathname}?${currentSearch}`
          : pathname;
        const subscribeUrl = `/upgrade/subscribe?redirect=${encodeURIComponent(fullPath)}`;
        if (newWindow) window.open(subscribeUrl);
        else return router.push(subscribeUrl);
      } else {
        if (newWindow) window.open("/upgrade/subscribe");
        else return router.push("/upgrade/subscribe");
      }
    },
    [pathname, router, searchParams.toString()],
  );

  return { redirectToSubscribe };
};
